import { API_REQUEST_PREFIX } from '@shared/config/api/api-prefixes';
import { requestBaseApi } from './base';
import {
    CreateRequestDataRequest,
    CreateRequestsDataResponse,
    RequestsListDataRequest,
    RequestsListDataResponse,
    UpdateRequestDataResponse,
    UpdateRequestsDataRequest,
} from './request-types';
import { queryParametersToString } from '@shared/lib/utils/query-parameters-to-string/query-parameters-to-string';

export const requestApi = requestBaseApi.injectEndpoints({
    endpoints: (build) => ({
        requestsList: build.query<RequestsListDataResponse, RequestsListDataRequest>({
            query: (parameters) => `${API_REQUEST_PREFIX}${queryParametersToString({ ...parameters })}`,
            providesTags: ['RequestsList'],
        }),
        createRequest: build.mutation<CreateRequestsDataResponse, CreateRequestDataRequest>({
            query: (data) => {
                return {
                    url: API_REQUEST_PREFIX,
                    method: 'POST',
                    body: { ...data },
                };
            },
            invalidatesTags: ['RequestsList'],
        }),
        updateRequest: build.mutation<UpdateRequestDataResponse, UpdateRequestsDataRequest>({
            query: ({ body }) => {
                return {
                    url: `${API_REQUEST_PREFIX}/${body.requestId}`,
                    method: 'POST',
                    body,
                };
            },
            invalidatesTags: ['RequestsList'],
        }),
    }),
});

export const { useLazyRequestsListQuery, useCreateRequestMutation, useUpdateRequestMutation } = requestApi;
